<template>
  <button class="k-icon-button btn-icon"
    :class="classes"
    :aria-label="ariaLabel"
    :title="title || ariaLabel"
    :disabled="disabled"
    @click.prevent="$emit('onClick', $event)"
  >
    <i :class="icon" aria-hidden="true"></i>
  </button>
</template>

<style scoped>
.k-icon-button.btn-icon.btn {
  padding: 4px 8px;
}

button:disabled {
  background-color: transparent;
  cursor: not-allowed;
}
</style>

<script>
export default {
  props: {
    icon: {
      type: String,
      required: true,
    },
    classes: {
      type: [String, Array],
    },
    title: {
      type: String,
      default: '',
    },
    ariaLabel: {
      type: String,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
